// extracted by mini-css-extract-plugin
export default {"wrap":"ZE-z","fullWidth":"_E-z","hideOnDesktop":"aF-z","content":"bF-z","hasOpenedNav":"cF-z","crumbsList":"dF-z","dropdownsWrap":"eF-z"};